<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <FolderMediaForm
      v-if="!isLoading"
      :folderMediaData="employeesFoldersMedias.employeesFoldersMedia"
      :defaultImg="''"
      v-on:addOrUpdateEmployeesFoldersMedia="addOrUpdateEmployeesFoldersMedia"
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import FolderMediaForm from "@/components/employees/employeesFoldersMedias/FolderMediaForm.vue";
import EmployeesFoldersMedias from "@/models/employees/employeesFoldersMedias/EmployeesFoldersMedias";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "FolderMediaAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    FolderMediaForm,
  },
  computed: {
    ...mapGetters(["employeeFolderToken"]),
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      employeesFoldersMedias: new EmployeesFoldersMedias(),
    };
  },
  methods: {
    async addOrUpdateEmployeesFoldersMedia() {
      this.isLoading = true;

      try {
        let response =
          await this.employeesFoldersMedias.employeesFoldersMedia.addOrUpdateEmployeesFoldersMedia(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.employeesFoldersMedias.employeesFoldersMedia.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    setFilter() {
      this.employeesFoldersMedias.employeesFoldersMedia.employeeFolderToken =
        this.employeeFolderToken;
    },
  },
  async created() {
    this.setFilter();
  },
};
</script>
